import { createRouter, createWebHistory } from 'vue-router'
import { isLoggedIn, clearTokens } from '@/utils/token.js'
import LoginPage from '@/views/LoginPage.vue'
import DashboardPage from '@/views/dashboard/DashboardPage.vue'
import OrderStatusPage from '@/views/order/OrderStatusPage.vue'
import ProductWithdrawalDetailPage from '@/views/order/ProductWithdrawalDetailPage.vue'
// 현금 출금 신청 (HQ 전용)
import CashWithdrawPage from '@/views/order/CashWithdrawPage.vue'
import MemberListPage from '@/views/members/MemberListPage.vue'
import MemberDetailPage from '@/views/members/MemberDetailPage.vue'
import BranchListPage from '@/views/branches/BranchListPage.vue'
import BranchCreatePage from '@/views/branches/BranchCreatePage.vue'
import BranchDetailPage from '@/views/branches/BranchDetailPage.vue'
import HqAdminListPage from '@/views/admins/HqAdminListPage.vue'
import TradeListPage from '@/views/trade/TradeListPage.vue'
import TradeDetailPage from '@/views/trade/TradeDetailPage.vue'
// 정산관리 (통합원장 전체 조회)
import SettlementListPage from '@/views/settlement/SettlementListPage.vue'
import SettlementDetailPage from '@/views/settlement/SettlementDetailPage.vue'
import AppraisalListPage from '@/views/appraisal/AppraisalListPage.vue'
import AppraisalDetailPage from '@/views/appraisal/AppraisalDetailPage.vue'
import PenaltyListPage from '@/views/appraisal/PenaltyListPage.vue'
import InquiryListPage from '@/views/inquiry/InquiryListPage.vue'
import InquiryDetailPage from '@/views/inquiry/InquiryDetailPage.vue'
import SiteBoardListPage from '@/views/site-board/SiteBoardListPage.vue'
import SiteBoardFormPage from '@/views/site-board/SiteBoardFormPage.vue'
// 상품관리
import CategoryListPage from '@/views/products/CategoryListPage.vue'
import ProductListPage from '@/views/products/ProductListPage.vue'
import ProductCreatePage from '@/views/products/ProductCreatePage.vue'
import ProductDetailPage from '@/views/products/ProductDetailPage.vue'
// 정책설정 (HQ 전용)
import TradePolicyListPage from '@/views/trade-policy/TradePolicyListPage.vue'
import TradePolicyDetailPage from '@/views/trade-policy/TradePolicyDetailPage.vue'
// 현물시세 (HQ 전용)
import MetalPricePage from '@/views/metal-price/MetalPricePage.vue'
import BusinessCalendarPage from '@/views/business-calendar/BusinessCalendarPage.vue'
// 감정평가 현물관리 — appraisal_item (HQ 전용)
import AppraisalSpotItemPage from '@/views/appraisal/AppraisalSpotItemPage.vue'
import { getAdminInfo } from '@/utils/token.js'

function requireHq(to, from, next) {
  const { adminType } = getAdminInfo()
  if (adminType !== 'HQ') {
    next('/dashboard')
  } else {
    next()
  }
}

const router = createRouter({
  history: createWebHistory(),
  routes: [
    { path: '/', redirect: '/login' },
    {
      path: '/login',
      component: LoginPage,
      meta: { layout: 'blank', title: '로그인', public: true },
    },
    {
      path: '/dashboard',
      component: DashboardPage,
      meta: { title: '대시보드' },
    },
    {
      path: '/order-status/:paymentCode',
      component: ProductWithdrawalDetailPage,
      meta: { title: '인출 상세' },
    },
    {
      path: '/order-status',
      component: OrderStatusPage,
      meta: { title: '인출하기' },
    },
    {
      path: '/cash-withdraw',
      component: CashWithdrawPage,
      meta: { title: '출금 신청', hqOnly: true },
      beforeEnter: requireHq,
    },
    {
      path: '/members',
      component: MemberListPage,
      meta: { title: '회원관리' },
    },
    {
      path: '/members/:userCode',
      component: MemberDetailPage,
      meta: { title: '회원 상세' },
    },
    {
      path: '/branches',
      component: BranchListPage,
      meta: { title: '지점관리' },
    },
    {
      path: '/branches/create',
      component: BranchCreatePage,
      meta: { title: '지점 등록' },
    },
    {
      path: '/branches/:branchCode',
      component: BranchDetailPage,
      meta: { title: '지점 상세' },
    },
    {
      path: '/hq-admins',
      component: HqAdminListPage,
      meta: { title: '본사관리자 관리', hqOnly: true },
      beforeEnter: requireHq,
    },
    {
      path: '/trade',
      component: TradeListPage,
      meta: { title: '매수·매도' },
    },
    {
      path: '/trade/:p2pAskCode',
      component: TradeDetailPage,
      meta: { title: '매수·매도 상세' },
    },
    // 정산관리 (통합원장 전체 - 거래유형 구분 없이 조회)
    {
      path: '/settlement',
      component: SettlementListPage,
      meta: { title: '정산관리' },
    },
    {
      path: '/settlement/:tradeUnifiedLedgerCode',
      component: SettlementDetailPage,
      meta: { title: '정산 상세' },
    },
    {
      path: '/appraisal',
      component: AppraisalListPage,
      meta: { title: '감정평가' },
    },
    {
      path: '/appraisal/:code',
      component: AppraisalDetailPage,
      meta: { title: '감정평가 상세' },
    },
    {
      path: '/appraisal-penalties',
      component: PenaltyListPage,
      meta: { title: '패널티 목록' },
    },
    {
      path: '/appraisal-spot-items',
      component: AppraisalSpotItemPage,
      meta: { title: '감정평가 현물관리', hqOnly: true },
      beforeEnter: (to, from, next) => {
        const { adminType } = getAdminInfo()
        if (adminType !== 'HQ') {
          next('/dashboard')
        } else {
          next()
        }
      },
    },
    {
      path: '/inquiries',
      component: InquiryListPage,
      meta: { title: '1:1 문의' },
    },
    {
      path: '/inquiries/:boardCode',
      component: InquiryDetailPage,
      meta: { title: '1:1 문의 상세' },
    },
    {
      path: '/notices',
      component: SiteBoardListPage,
      meta: { title: '공지사항', boardKind: 'notice' },
      beforeEnter: requireHq,
    },
    {
      path: '/notices/new',
      component: SiteBoardFormPage,
      meta: { title: '공지 등록', boardKind: 'notice' },
      beforeEnter: requireHq,
    },
    {
      path: '/notices/:boardCode',
      component: SiteBoardFormPage,
      meta: { title: '공지 수정', boardKind: 'notice' },
      beforeEnter: requireHq,
    },
    {
      path: '/faqs',
      component: SiteBoardListPage,
      meta: { title: '자주묻는 질문', boardKind: 'faq' },
      beforeEnter: requireHq,
    },
    {
      path: '/faqs/new',
      component: SiteBoardFormPage,
      meta: { title: 'FAQ 등록', boardKind: 'faq' },
      beforeEnter: requireHq,
    },
    {
      path: '/faqs/:boardCode',
      component: SiteBoardFormPage,
      meta: { title: 'FAQ 수정', boardKind: 'faq' },
      beforeEnter: requireHq,
    },
    // 상품관리
    {
      path: '/products/categories',
      component: CategoryListPage,
      meta: { title: '상품 카테고리 관리' },
    },
    {
      path: '/products',
      component: ProductListPage,
      meta: { title: '상품 관리' },
    },
    {
      path: '/products/create',
      component: ProductCreatePage,
      meta: { title: '상품 등록' },
    },
    {
      path: '/products/:productCode',
      component: ProductDetailPage,
      meta: { title: '상품 상세' },
    },
    // 현물시세 (HQ 전용) - 금/은 시세 이력 차트
    {
      path: '/metal-price',
      component: MetalPricePage,
      meta: { title: '현물시세', hqOnly: true },
      beforeEnter: (to, from, next) => {
        const { adminType } = getAdminInfo()
        if (adminType !== 'HQ') {
          next('/dashboard')
        } else {
          next()
        }
      },
    },
    {
      path: '/business-calendar',
      component: BusinessCalendarPage,
      meta: { title: '영업일 관리' },
    },
    // 정책설정 (HQ 전용)
    {
      path: '/trade-policy',
      component: TradePolicyListPage,
      meta: { title: '정책 설정', hqOnly: true },
      beforeEnter: (to, from, next) => {
        const { adminType } = getAdminInfo()
        if (adminType !== 'HQ') {
          next('/dashboard')
        } else {
          next()
        }
      },
    },
    {
      path: '/trade-policy/:tradePolicyCode',
      component: TradePolicyDetailPage,
      meta: { title: '정책 상세', hqOnly: true },
      beforeEnter: (to, from, next) => {
        const { adminType } = getAdminInfo()
        if (adminType !== 'HQ') {
          next('/dashboard')
        } else {
          next()
        }
      },
    },
    { path: '/:pathMatch(.*)*', redirect: '/dashboard' },
  ],
})

router.beforeEach((to, from, next) => {
  const loggedIn = isLoggedIn()
  if (!to.meta?.public && !loggedIn) {
    // 토큰이 없거나 접근 · 갱신 토큰의 exp 가 둘 다 지났다 - 화면을 그리기 전에 로그인으로 보낸다(모달 없이).
    // 끝난 세션이니 남은 토큰 · 관리자 정보도 지운다.
    clearTokens()
    next({ path: '/login', replace: true })
  } else if (to.path === '/login' && loggedIn) {
    next('/dashboard')
  } else {
    next()
  }
})

export default router
